<script setup lang="ts">
const props = defineProps<{
  progressToAnotherLevel: number;
  userPointsInLevel: number;
  pointsToNextLevel: number;
  nextUserLevel: any;
}>();
</script>

<template>
  <div class="progress-section-to-next-level">
    <span class="progress-section-title-to-next">
      <span>{{ $t('gamification.levels.progress_to_next_level') }}</span>
    </span>
    <div class="progress-section-user-progress">
      <div class="progress-section-progress-bar">
        <div
          class="progress-section-progress-bar-fill flex items-center justify-center h-full bg-green-500 transition-all duration-300"
          :style="`width: ${props.progressToAnotherLevel}%`"
        ></div>
        <span
          class="absolute inset-0 flex items-center justify-center text-white text-xs font-semibold whitespace-nowrap"
        >
          {{ Math.round(props.progressToAnotherLevel) }}%
        </span>
      </div>
    </div>
    <div class="progress-section-levels-label">
      <div class="progress-section-progress-number">
        {{ props.userPointsInLevel }} / {{ props.pointsToNextLevel }}
      </div>
      <div
        class="progress-section-level-badge flex flex-row items-center gap-2 text-white font-semibold"
      >
        <img
          :alt="props.nextUserLevel.name"
          class="w-5 h-5 md:w-6 md:h-6"
          :src="props.nextUserLevel.image"
        />
        <span class="whitespace-nowrap">{{ props.nextUserLevel.name }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="postcss">
.progress-section-to-next-level {
  @apply w-full max-w-[280px] mx-auto mt-4 flex flex-col items-center justify-center px-2;

  .progress-section-title-to-next {
    @apply text-[.68rem] text-texts;
  }

  .progress-section-user-progress {
    @apply relative w-full h-4 rounded-full overflow-hidden mt-1;
    .progress-section-progress-bar {
      @apply w-full h-full bg-texts/20 overflow-hidden;
    }
    .progress-section-progress-bar-fill {
      @apply h-full bg-primary rounded-l;
    }
  }

  .progress-section-levels-label {
    @apply flex justify-between items-center mt-0.5 w-full;
    .progress-section-progress-number {
      @apply text-texts font-semibold text-[.68rem] whitespace-nowrap;
    }
    .progress-section-level-badge {
      @apply p-0 bg-transparent max-w-[50%] m-0 gap-0.5 text-[.68rem];
      img {
        @apply w-[10px] md:w-[12px];
      }
    }
  }
}
</style>
